import { AppFixture, ActionFixture } from '../types';

/**
 * Remove the `topic` need from the array of returned needs.
 * Sets the `topic` param to the passed value.
 */
const removeTopicNeedAndSetParam = (topicValue: string): ActionFixture => ({
  needs: (needs) => needs.filter(({ key }) => key !== 'topic'),
  params: (params) => ({ ...params, topic: topicValue }),
});

const fixture: AppFixture = {
  booking: removeTopicNeedAndSetParam('booking.created'),
  couponHook: removeTopicNeedAndSetParam('coupon.created'),
  customerHook: removeTopicNeedAndSetParam('customer.created'),
  orderHook: removeTopicNeedAndSetParam('order.created'),
  orderLine: removeTopicNeedAndSetParam('order.created'),
  productHook: removeTopicNeedAndSetParam('product.created'),
  subscriptionHook: removeTopicNeedAndSetParam('subscription.created'),
};

export default fixture;
